export default __webpack_public_path__ + "static/SectionTwo_01_01@2x-604368418e88560e4ddafe1794f43a5f.webp";